import {
  DialogBody,
  DialogSubClose,
  DialogSubHeader,
} from '@src/design-system/dialog';
import { Label } from '@src/design-system/label';
import { useFormikContext } from 'formik';
import { Status } from '@src/design-system/status';
import { appointmentFormNames } from '@shared/forms/appointment';
import { SearchInput } from '@src/design-system/molecules/search-input';
import { AnimatedTransition } from '@src/design-system/animated-transition';
import InfiniteScroll from '@src/design-system/infinite-scroll';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { Loader2 } from 'lucide-react';
import meetingTemplateApi from '@features/participants/services/meeting-template';
import parse from 'html-react-parser';

export function ChooseAppointmentTemplateSubModal() {
  const { search } = useLocation();
  const queryParam = qs.parse(search, { ignoreQueryPrefix: true });

  const { data, isPending, fetchNextPage, hasNextPage } =
    meetingTemplateApi.useFetchInfinite({
      name: queryParam.templateName as string,
    });
  const templates = data?.pages.flatMap((page) => page.results);

  const { setFieldValue, setFieldTouched } = useFormikContext();

  const { description, interviewType, appointmentType } = appointmentFormNames;
  const skeleton = (
    <div className='w-full flex items-center justify-center mt-4'>
      <Loader2
        className='animate-spin text-primary-1000'
        size={24}
      />
    </div>
  );
  return (
    <>
      <DialogSubHeader>Choose Template</DialogSubHeader>
      <DialogBody className='pt-0 mt-0'>
        <div className='mb-4'>
          <SearchInput queryKey='templateName' />
        </div>

        <AnimatedTransition
          animateOnEveryRender
          isPending={isPending}
          skeleton={
            <div className='w-full text-sm flex justify-center items-center h-[350px]'>
              {skeleton}
            </div>
          }
        >
          <div
            className='max-h-[350px] overflow-auto'
            style={{ scrollbarWidth: 'none' }}
          >
            {!templates?.length && !isPending && (
              <span className='w-full text-gray-600 text-sm flex justify-center items-center h-[350px]'>
                No templates found
              </span>
            )}
            <ul>
              {templates?.map((template) => {
                return (
                  <li
                    key={template.id}
                    value={template.name}
                    onClick={() => {
                      setFieldValue(description, template.description);
                      setFieldTouched(description, false);

                      setFieldValue(interviewType, template.interview_type);
                      setFieldTouched(interviewType, false);

                      setFieldValue(appointmentType, template.type);
                      setFieldTouched(appointmentType, false);
                    }}
                    className='border block cursor-pointer overflow-hidden mb-3 last:mb-0 border-pale-border p-4 rounded-lg'
                  >
                    <DialogSubClose>
                      <div className='flex justify-between items-center'>
                        <Label className='mb-0'>{template.name}</Label>
                        <Status variant={'inActive'}>{template.type}</Status>
                      </div>

                      <div className='flex items-center w-[85%] text-gray-600 text-sm'>
                        {parse(template.description)}
                      </div>
                    </DialogSubClose>
                  </li>
                );
              })}
            </ul>
            <InfiniteScroll
              hasMore={hasNextPage}
              threshold={0.8}
              isLoading={isPending}
              next={fetchNextPage}
            >
              {hasNextPage && skeleton}
            </InfiniteScroll>
          </div>
        </AnimatedTransition>
      </DialogBody>
    </>
  );
}
